module.exports = __webpack_public_path__ + "media/images/custom-pin-d323b38c8f4d3a240b3793633f0ff7a3.svg";